var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m5.37 6.3c-.25 0-.51-.1-.7-.29l-4.37-4.3c-.39-.38-.4-1.02-.01-1.41s1.02-.4 1.41-.01l3.67 3.61 3.67-3.61c.39-.39 1.03-.38 1.41.01.39.39.38 1.03-.01 1.41l-4.37 4.3c-.19.19-.45.29-.7.29z"}));
}

Arrow.defaultProps = {"viewBox":"0 0 10.74 6.3"};

module.exports = Arrow;

Arrow.default = Arrow;
